import { render, staticRenderFns } from "./TextInput.vue?vue&type=template&id=543bacf9&scoped=true"
import script from "./TextInput.vue?vue&type=script&lang=js"
export * from "./TextInput.vue?vue&type=script&lang=js"
import style0 from "./TextInput.vue?vue&type=style&index=0&id=543bacf9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543bacf9",
  null
  
)

export default component.exports